import { SHA3 } from "sha3";

/**
 * Crea hash
 * 
 * @param {string} data - Recibe el texto que se desea convertir en hash.
 * @return {string} - Retorna hash generado | "".
 */
export const crearHash = (data:any): string => {
    let hash256:any = new SHA3(256);
    hash256.update(data);
    hash256 = hash256.digest("hex");
    return hash256 || "";
}

